import React from 'react'
import PropTypes from 'prop-types'
import CardHorizontalActions from '../cards/card-horizontal-actions'
import values from 'lodash/values'
import { ORDER_STATE } from '../../services/myprofile/constants'

const CardListItem = props => (
  <li>
    <CardHorizontalActions
      title={props.title}
      subtitle={props.subtitle}
      subsubtitle={props.subsubtitle}
      caption={props.caption}
      imageUrl={props.imageUrl}
      imagePlaceholder={props.imagePlaceholder}
      hasStateTag={props.hasStateTag}
      tagType={props.tagType}
      tagBackground={props.tagBackground}
      tagText={props.tagText}
      tagIcon={props.tagIcon}
      hasActions={props.hasActions}
      onViewDetail={props.onViewDetail}
      onEdit={props.onEdit}
      onDelete={props.onDelete}
      orderState={props.orderState}
    />
  </li>
)

CardListItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subsubtitle: PropTypes.string,
  caption: PropTypes.string,
  imageUrl: PropTypes.string,
  imagePlaceholder: PropTypes.string,
  hasStateTag: PropTypes.bool,
  tagType: PropTypes.oneOf(['success', 'warning', 'info']),
  tagBackground: PropTypes.bool,
  tagText: PropTypes.string,
  tagIcon: PropTypes.string,
  hasActions: PropTypes.bool,
  onViewDetail: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  orderState: PropTypes.oneOf(values(ORDER_STATE))
}

export default CardListItem



// WEBPACK FOOTER //
// ./src/ui/cards/card-list-item.js